import type { FC } from "react";

interface HtmlRendererProps {
  content: string;
  downloadUrl?: string;
}

/**
 * Renders HTML artifacts in a fully sandboxed iframe.
 *
 * SECURITY: The `sandbox` attribute with NO allow values grants zero
 * permissions — no scripts, no forms, no popups, no same-origin access.
 * Content is injected via `srcdoc`, never via `src` or `dangerouslySetInnerHTML`.
 */
export const HtmlRenderer: FC<HtmlRendererProps> = ({
  content,
  downloadUrl,
}) => {
  if (!content) {
    return (
      <div className="cuadra-p-4 cuadra-text-sm cuadra-text-[var(--cuadra-text-secondary)]">
        No content
      </div>
    );
  }

  return (
    <div className="cuadra-flex cuadra-flex-col cuadra-h-full">
      {downloadUrl && (
        <div className="cuadra-flex cuadra-justify-end cuadra-px-3 cuadra-py-2 cuadra-border-b cuadra-border-[var(--cuadra-border)] cuadra-bg-[var(--cuadra-bg-secondary)]">
          <a
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="cuadra-text-xs cuadra-text-[var(--cuadra-text-secondary)] hover:cuadra-text-[var(--cuadra-text-primary)] cuadra-underline cuadra-transition-colors"
          >
            Run in new tab
          </a>
        </div>
      )}
      <iframe
        sandbox=""
        srcDoc={content}
        title="HTML artifact"
        className="cuadra-flex-1 cuadra-w-full cuadra-border-0 cuadra-bg-white"
      />
    </div>
  );
};
